import React, {
  MouseEventHandler,
  useCallback,
  useEffect,
  useMemo
} from 'react';

import { TrackingEventNames } from 'common/constants/trackingEventsNames';
import eventEmitter from 'common/services/events/eventEmitter';
import trans from 'common/tools/translations/trans';

import { PartialTheater } from 'website/containers/showtimes/utils/types';
import loadAccesLibre from 'website/third_party/acces-libre';

type AccesLibreLinkProps = {
  theater?: PartialTheater;
};

const label = trans('theater.libreacces.link');

const AccesLibreLink = ({ theater }: AccesLibreLinkProps) => {
  const uuid = useMemo(() => theater?.accesLibre?.uuid, [theater]);

  useEffect(() => {
    loadAccesLibre(true);
  }, []);

  const handleClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
    evt => {
      evt.preventDefault();
      if (uuid) {
        window.acceslibre?.openAccessibilityModal?.(uuid);
        eventEmitter.emit(TrackingEventNames.OPEN_ACCESSIBILITY_MODAL, {
          theater
        });
      }
    },
    [uuid]
  );

  return (
    uuid && (
      <a
        href="#"
        aria-haspopup="dialog"
        aria-controls="dialog"
        className="acces-libre-link"
        onClick={handleClick}
      >
        {label}
      </a>
    )
  );
};

export default AccesLibreLink;
